import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Heading, HeadingType } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import ProductFeature from '../../components/product-detail/product-feature/ProductFeature';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
export const MIN_FEATURES = 2;
const PRODUCT_FEATURES_ID = 'product-features';
const ProductFeaturesContainer = ({ technicalFeatures }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsxs(Box, { mobile: { spacing: { marginTop: 2 } }, tablet: { spacing: { marginTop: 3 } }, id: PRODUCT_FEATURES_ID, children: [_jsx(Heading, { type: HeadingType.TITLE, children: t('product.features.title') }), _jsx(Box, { mobile: { spacing: { marginTop: 2 } }, desktop: { spacing: { marginTop: 3 } }, children: technicalFeatures.map((feature, index) => (_jsx(ProductFeature, { feature: feature, isFirstFeature: index === 0 }, feature.featureId))) })] }));
};
export default ProductFeaturesContainer;
